module.exports = __webpack_public_path__ + "src-notif-ru.png?a62ef34068f93af7e242ba90ed08df23";